import "./notFound.scss";

import React from "react";

const NotFound = () => {
  return (
    <section className="data-sheet container is-fluid">
      <div className="">
        <div className="notFound">
          <div>0 entreprise correspond à votre requête</div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
